module.exports = __webpack_public_path__ + "3219e8caf3c6160a871312051ded8ca6.png";